export const GET_VEHICLE = "GET_VEHICLE";
export const GET_VEHICLE_SUCCESS = "GET_VEHICLE_SUCCESS";
export const GET_VEHICLE_ERROR = "GET_VEHICLE_ERROR";

export const SET_ONE_VEHICLE_FILTERS = "SET_ONE_VEHICLE_FILTERS";
